import { render, staticRenderFns } from "./TypeAndFio.vue?vue&type=template&id=f1710742&"
import script from "./TypeAndFio.vue?vue&type=script&lang=js&"
export * from "./TypeAndFio.vue?vue&type=script&lang=js&"
import style0 from "./TypeAndFio.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports